import { useMemo } from "react";
import { LayoutDashboard } from "lucide-react";
import type { WelcomeHeaderProps } from "../../types/dashboard";

export const WelcomeHeader = ({ gymName, email }: WelcomeHeaderProps) => {
  const capitalizedDate = useMemo(() => {
    const dateStr = new Date().toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
  }, []);

  return (
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-xl bg-global-overlay-secondary border border-global-primary flex items-center justify-center shrink-0">
        <LayoutDashboard
          className="w-[18px] h-[18px] text-global-accent"
          aria-hidden="true"
        />
      </div>
      <div>
        <h1 className="text-title-page leading-tight">
          {gymName ?? "Dashboard"}
        </h1>
        <p className="text-size-xs text-global-muted">
          <span>{capitalizedDate}</span>
          {email && (
            <span className="ml-2 opacity-60 break-all sm:break-normal">
              · {email}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};
